import React, { useState } from "react";
// import { DownOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  DatePicker,
  Select,
  ConfigProvider,
} from "antd";
import zhCN from "antd/es/locale/zh_CN"; // 引入语言包
import moment from "moment";
import dayjs from "dayjs";
import "moment/locale/zh-cn";
moment.locale("zh-cn"); // 注意这里设置 moment 必须放在有 import 的后面。
const { RangePicker } = DatePicker;
const { Option } = Select;

const initParams = {
  batchNo: "",
  command: "",
  longCmd: "",
  remark: "",
  start: "",
  end: "",
};

export default function SearchHead(props) {
  const [form] = Form.useForm();
  // const [expand, setExpand] = useState(false);

  // 运行业务时间
  const [askBusinessTime, setAskBusinessTime] = useState({
    start: "",
    end: "",
  });

  // 搜索
  const onFinish = (values) => {
    delete values.askBusinessTime;
    delete values.createTime;
    delete values.leaveTime;
    props.handleSearch({
      ...initParams,
      ...values,
      ...askBusinessTime,
    });
  };

  //
  const onChangeDate = (dates, dateStrings, mode) => {
    if (mode === "askBusinessTime") {
      setAskBusinessTime(() => ({
        start: dateStrings?.[0] || "",
        end: dateStrings?.[1] || "",
      }));
    }
  };

  // 重置
  const reset = () => {
    setAskBusinessTime(() => ({
      start: "",
      end: "",
    }));
    form.resetFields();
    props.handleSearch({
      ...initParams,
    });
    props.handleReset({
      ...initParams,
    });
  };

  return (
    <>
      <div className="search">
        <Form
          form={form}
          name="advanced_search"
          onFinish={onFinish}
          labelCol={{
            flex: "130px",
          }}
          labelAlign="right"
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="batchNo" label="批次号">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="command" label="命令内容">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="remark" label="备注">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="longCmd" label="命令类型">
                <Select placeholder="请选择命令类型" allowClear>
                  <Option value="1">长期命令</Option>
                  <Option value="0">短期命令</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <ConfigProvider locale={zhCN}>
                <Form.Item name="askBusinessTime" label="运行业务时间">
                  <RangePicker
                    onChange={(dates, dateStrings) =>
                      onChangeDate(dates, dateStrings, "askBusinessTime")
                    }
                    style={{ width: "100%" }}
                    showTime={{
                      hideDisabledOptions: true,
                      defaultValue: [
                        dayjs("00:00:00", "HH:mm:ss"),
                        dayjs("11:59:59", "HH:mm:ss"),
                      ],
                    }}
                    format="YYYY-MM-DD HH:mm:ss"
                  />
                </Form.Item>
              </ConfigProvider>
            </Col>
          </Row>

          <div
            style={{
              textAlign: "center",
            }}
          >
            <Space size="small">
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
              <Button onClick={reset}>重置</Button>
            </Space>
          </div>
        </Form>
      </div>
      <div className="line"></div>
    </>
  );
}
